import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  item: {
    display: 'flex',
    width: '100%',
    alignSelf: 'center',
    justifyContent: 'center',
    height: '100%',
    padding: '15px',
  },
  verifyButton: {
    display: 'flex',
    width: '100%',
    alignSelf: 'flex-end',
    justifyContent: 'flex-end',
    height: '100%',
    paddingRight: '10px',
  },
  modalSubTitle: {
    fontFamily: 'Roboto',
    fontWeight: 700,
    fontSize: '16px',
    color: '#2C2D3E',
    marginBottom: '20px',
  },
  modalText: {
    fontFamily: 'Roboto',
    fontWeight: 500,
    fontSize: '13px',
    color: '#2C2D3E',
    marginBottom: '20px',
  },
  backButton: {
    position: 'relative',
    fontFamily: 'Roboto',
    fontStyle: 'normal',
    fontWeight: 500,
    fontSize: 14,
    lineHeight: '16px',
    color: '#3C419A',
    marginBottom: '34px',
    marginLeft: '13px',
    '&:hover': {
      cursor: 'pointer',
    },
  },
  backArrowIcon: {
    position: 'relative',
    top: '7px',
  },
  closeButton: {
    position: 'relative',
    marginLeft: '339px',
    marginTop: '15px',
    width: '30px',
    height: '30px',
    background: '#FFFFFF',
    border: '1px solid #2C2D3E',
    borderRadius: '3px',
    fontSize: 'small',
    '&:hover': {
      cursor: 'pointer',
    },
  },
  menuItem: {
    '&:hover': {
      backgroundColor: '#CACAFC33',
      color: '#3C419A',
    },
  },
  editUserButton: {
    width: '147px',
    marginLeft: '530px',
    marginTop: '85px',
    padding: '0px 0px 0px 0px',
    fontSize: 14,
    height: '36px',
    left: '59px',
    border: 'solid 1px #3C419A',
    color: '#3C419A',
    backgroundColor: '#FFFFFF',
    boxShadow: 'none',
    '&:hover': {
      backgroundColor: '#FFFFFF',
    },
  },
  errorMessagesContainer: {
    maxWidth: '300px',
    height: '10px',
    margin: '5px 0px 0px 5px',
  },
  errorMessage: {
    fontFamily: 'Roboto',
    color: '#BC0000',
    fontWeight: 400,
    fontSize: '12px',
  },
}));
